import React, { useState } from 'react';
import { Star, CheckCircle2, ArrowRight, Phone, Mail, MapPin, Menu, X, ChevronDown } from 'lucide-react';
export function HomePage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-[#1e3a5f]" data-id="element-4">
      {/* NAVIGATION */}
      <nav className="sticky top-0 z-50 bg-white border-b border-gray-100 shadow-sm" data-id="element-5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6">
          <div className="flex items-center justify-between h-20" data-id="element-7">
            {/* Logo */}
            <div className="flex-shrink-0" data-id="element-8">
              <a href="/" className="flex items-center" data-id="element-9">
                <img src="https://staging2.mindability-hypnotherapy.co.uk/wp-content/uploads/2022/07/MindAbilityLogoSquaredTAGvFFFFF2-3.gif" alt="MindAbility Hypnotherapy" className="h-16 w-auto" data-id="element-10" />
              </a>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-8" data-id="element-11">
              <a href="/what-is-hypnotherapy/" className="text-sm font-medium text-gray-700 hover:text-[#1e3a5f] transition-colors" data-id="element-12">
                what is hypnotherapy?
              </a>
              <div className="relative group" data-id="element-13">
                <button className="text-sm font-medium text-gray-700 hover:text-[#1e3a5f] transition-colors flex items-center gap-1" data-id="element-14">
                  services <ChevronDown className="w-4 h-4" data-id="element-15" />
                </button>
                <div className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200" data-id="element-16">
                  <div className="py-2" data-id="element-17">
                    <a href="/anxiety/" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-18">
                      Anxiety
                    </a>
                    <a href="/depression/" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-19">
                      Depression
                    </a>
                    <a href="/ocd/" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-20">
                      OCD
                    </a>
                    <a href="/fears-and-phobias/" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-21">
                      Fears and Phobias
                    </a>
                    <a href="/smoking/" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-22">
                      Smoking
                    </a>
                    <a href="/performance-anxiety/" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-23">
                      Performance Anxiety
                    </a>
                    <a href="/stress-burnout-support/" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-24">
                      Stress & Burnout Support
                    </a>
                    <a href="/weight-management/" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" data-id="element-25">
                      Weight Management
                    </a>
                  </div>
                </div>
              </div>
              <a href="/resources/" className="text-sm font-medium text-gray-700 hover:text-[#1e3a5f] transition-colors" data-id="element-26">
                resources
              </a>
              <a href="/location/" className="text-sm font-medium text-gray-700 hover:text-[#1e3a5f] transition-colors" data-id="element-27">
                location
              </a>
              <a href="/corporate/" className="text-sm font-medium text-gray-700 hover:text-[#1e3a5f] transition-colors" data-id="element-28">
                corporate
              </a>
              <a href="/blog/" className="text-sm font-medium text-gray-700 hover:text-[#1e3a5f] transition-colors" data-id="element-29">
                blog
              </a>
            </div>

            {/* Right Side - CTA, Phone, Profile */}
            <div className="hidden lg:flex items-center space-x-4" data-id="element-30">
              <a href="/fees-booking/" className="bg-[#1e3a5f] text-white px-6 py-2.5 rounded-full font-bold text-sm hover:bg-[#162d4a] transition-colors" data-id="element-31">
                Fees & Booking
              </a>
              <a href="tel:07902580703" className="flex items-center gap-2 text-sm font-medium text-gray-700 hover:text-[#1e3a5f] transition-colors" data-id="element-32">
                <Phone className="w-4 h-4" data-id="element-33" />
                07902 580703
              </a>
              <img src="https://staging2.mindability-hypnotherapy.co.uk/wp-content/uploads/2025/12/1-75x75.jpg" alt="Asha" className="w-10 h-10 rounded-full object-cover border-2 border-gray-200" data-id="element-34" />
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100" data-id="element-35">
              {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-36" /> : <Menu className="w-6 h-6" data-id="element-37" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && <div className="lg:hidden border-t border-gray-100 bg-white" data-id="element-38">
            <div className="px-4 py-4 space-y-3" data-id="element-39">
              <a href="/what-is-hypnotherapy/" className="block py-2 text-sm font-medium text-gray-700" data-id="element-40">
                what is hypnotherapy?
              </a>
              <div data-id="element-41">
                <button onClick={() => setServicesOpen(!servicesOpen)} className="flex items-center justify-between w-full py-2 text-sm font-medium text-gray-700" data-id="element-42">
                  services
                  <ChevronDown className={`w-4 h-4 transition-transform ${servicesOpen ? 'rotate-180' : ''}`} data-id="element-43" />
                </button>
                {servicesOpen && <div className="pl-4 mt-2 space-y-2" data-id="element-44">
                    <a href="/anxiety/" className="block py-1.5 text-sm text-gray-600" data-id="element-45">
                      Anxiety
                    </a>
                    <a href="/depression/" className="block py-1.5 text-sm text-gray-600" data-id="element-46">
                      Depression
                    </a>
                    <a href="/ocd/" className="block py-1.5 text-sm text-gray-600" data-id="element-47">
                      OCD
                    </a>
                    <a href="/fears-and-phobias/" className="block py-1.5 text-sm text-gray-600" data-id="element-48">
                      Fears and Phobias
                    </a>
                    <a href="/smoking/" className="block py-1.5 text-sm text-gray-600" data-id="element-49">
                      Smoking
                    </a>
                    <a href="/performance-anxiety/" className="block py-1.5 text-sm text-gray-600" data-id="element-50">
                      Performance Anxiety
                    </a>
                    <a href="/stress-burnout-support/" className="block py-1.5 text-sm text-gray-600" data-id="element-51">
                      Stress & Burnout Support
                    </a>
                    <a href="/weight-management/" className="block py-1.5 text-sm text-gray-600" data-id="element-52">
                      Weight Management
                    </a>
                  </div>}
              </div>
              <a href="/resources/" className="block py-2 text-sm font-medium text-gray-700" data-id="element-53">
                resources
              </a>
              <a href="/location/" className="block py-2 text-sm font-medium text-gray-700" data-id="element-54">
                location
              </a>
              <a href="/corporate/" className="block py-2 text-sm font-medium text-gray-700" data-id="element-55">
                corporate
              </a>
              <a href="/blog/" className="block py-2 text-sm font-medium text-gray-700" data-id="element-56">
                blog
              </a>
              <div className="pt-4 border-t border-gray-100 space-y-3" data-id="element-57">
                <a href="/fees-booking/" className="block w-full bg-[#1e3a5f] text-white px-6 py-3 rounded-full font-bold text-sm text-center hover:bg-[#162d4a] transition-colors" data-id="element-58">
                  Fees & Booking
                </a>
                <a href="tel:07902580703" className="flex items-center justify-center gap-2 text-sm font-medium text-gray-700" data-id="element-59">
                  <Phone className="w-4 h-4" data-id="element-60" />
                  07902 580703
                </a>
              </div>
            </div>
          </div>}
      </nav>

      <main data-id="element-61">
        {/* SECTION 0 — HERO */}
        <section className="pt-8 pb-6 px-4 max-w-7xl mx-auto" data-id="element-62">
          <div className="bg-[#eef4fb] rounded-[2rem] overflow-hidden flex flex-col lg:flex-row items-stretch shadow-sm" data-id="element-63">
            <div className="w-full lg:w-1/2 relative min-h-[350px] lg:min-h-[500px]" data-id="element-64">
              <img src="https://cdn.magicpatterns.com/uploads/jXrAyLm7PSjjzrEshZuigQ/AshaMiniShoot-6_(1).jpg" alt="Asha, Hypnotherapist" className="absolute inset-0 w-full h-full object-cover" style={{
              objectPosition: 'center 20%'
            }} data-id="element-65" />
            </div>
            <div className="w-full lg:w-1/2 p-8 md:p-12 lg:p-16 flex flex-col justify-center space-y-6" data-id="element-66">
              <h1 className="text-4xl md:text-5xl font-bold text-[#1e3a5f] leading-tight" data-id="element-67">
                You look calm.
                <br data-id="element-68" />
                Inside, it's chaos.
              </h1>
              <h2 className="text-lg md:text-xl font-semibold text-[#1e3a5f] leading-snug" data-id="element-69">
                Hypnotherapy in Shirley, Solihull for high performing people
                with busy minds, tired bodies, and zero time to fall apart.
              </h2>
              <p className="text-gray-600 leading-relaxed text-sm md:text-base" data-id="element-70">
                If your brain won't switch off, you're stuck in a loop of
                overwhelm → procrastination → guilt, and you're losing your
                enjoyment of work and home, this is what high-pressure stress
                looks like when it's been going on too long. You're not failing.
                You're overloaded, and you don't have to be in survival mode.
              </p>
              <div className="pt-2" data-id="element-71">
                <a href="https://mindability-hypnotherapy.co.uk/book-now/" className="inline-flex items-center justify-center bg-[#1e3a5f] text-white px-8 py-4 rounded-lg font-bold text-sm shadow-md hover:bg-[#162d4a] transition-colors" data-id="element-72">
                  Book a free 15 minute call{' '}
                  <ArrowRight className="ml-2 w-4 h-4" data-id="element-73" />
                </a>
                <p className="mt-4 text-xs text-gray-500 font-medium leading-relaxed max-w-md" data-id="element-74">
                  In-person in Shirley, Solihull + online sessions •
                  Confidential • Practical, supportive, and straight-talking
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 0.5 — PROOF STRIP */}
        <section className="py-6 border-b border-gray-100" data-id="element-75">
          <div className="max-w-5xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-sm" data-id="element-76">
            <div className="flex items-center gap-2" data-id="element-77">
              <div className="flex text-yellow-400" data-id="element-78">
                <Star className="w-5 h-5 fill-current" data-id="element-79" />
                <Star className="w-5 h-5 fill-current" data-id="element-80" />
                <Star className="w-5 h-5 fill-current" data-id="element-81" />
                <Star className="w-5 h-5 fill-current" data-id="element-82" />
                <Star className="w-5 h-5 fill-current" data-id="element-83" />
              </div>
              <span className="font-bold text-[#1e3a5f]" data-id="element-84">5.0 ★ on Google</span>
            </div>
            <span className="hidden sm:block text-gray-300" data-id="element-85">|</span>
            <span className="font-medium text-gray-600" data-id="element-86">41+ Reviews</span>
            <span className="hidden sm:block text-gray-300" data-id="element-87">|</span>
            <a href="https://www.google.com/search?sca_esv=1cbbef248ef25653&sxsrf=ANbL-n7pETaMI9yphhyrFrqVFqypVUQdWQ:1774469458775&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOZDSDxVkT0rX36YmCveOt2ADYzGtRm6Auyn5jVdTjXYkd2EHYavdg42_m83vHI8SOHhXbHA33hbW5IaUpZLu9LodrF8JgEjXYPUs0pZItzvgy2JgEw%3D%3D&q=mindAbility+Hypnotherapy+Reviews&sa=X&ved=2ahUKEwiN6oTu7buTAxVRhf0HHSxfLnMQ0bkNegQIKRAH&biw=1920&bih=873&dpr=1" target="_blank" rel="noopener noreferrer" className="font-semibold text-[#4a7ab5] hover:underline" data-id="element-88">
              Read reviews
            </a>
            <span className="hidden sm:block text-gray-300" data-id="element-89">|</span>
            <span className="font-medium text-gray-600" data-id="element-90">
              Shirley, Solihull + Online
            </span>
          </div>
        </section>

        {/* SECTION 1 — FAST RECOGNITION */}
        <section className="py-20 px-4 bg-white" data-id="element-91">
          <div className="max-w-4xl mx-auto" data-id="element-92">
            <h3 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] text-center mb-12" data-id="element-93">
              If this is you, you're in the right place.
            </h3>
            <div className="grid md:grid-cols-2 gap-4 mb-12" data-id="element-94">
              {["You've gone from purpose to pressure — and you can't switch off", "You're overwhelmed, then procrastinate, then feel guilty", "You're exhausted, but your body won't properly rest, and your mind wont let you sleep", "You're snappy, numb, or shutting down at home", 'You look "fine" externally… and feel like you\'re quietly falling apart inside', 'Nothing feels good or exciting because everything is exhausting'].map((item, i) => <div key={i} className="flex items-start gap-4 bg-[#eef4fb] p-5 rounded-xl" data-id="element-95">
                  <CheckCircle2 className="w-6 h-6 text-[#4a7ab5] flex-shrink-0 mt-0.5" data-id="element-96" />
                  <span className="text-[#1e3a5f] font-medium leading-relaxed" data-id="element-97">
                    {item}
                  </span>
                </div>)}
            </div>
            <div className="text-center" data-id="element-98">
              <a href="https://mindability-hypnotherapy.co.uk/fees-booking/" className="inline-flex items-center justify-center bg-[#1e3a5f] text-white px-8 py-4 rounded-lg font-bold text-sm shadow-md hover:bg-[#162d4a] transition-colors" data-id="element-99">
                Book a free 15-minute call{' '}
                <ArrowRight className="ml-2 w-4 h-4" data-id="element-100" />
              </a>
            </div>
          </div>
        </section>

        {/* SECTION 2 — WHAT YOU WANT */}
        <section className="py-20 px-4 bg-[#eef4fb]" data-id="element-101">
          <div className="max-w-4xl mx-auto text-center" data-id="element-102">
            <h3 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-4" data-id="element-103">
              What you actually want.
            </h3>
            <p className="text-xl font-medium text-[#4a7ab5] mb-12" data-id="element-104">
              Not perfect. Not "zen." Just you again.
            </p>
            <div className="grid sm:grid-cols-2 gap-4 text-left" data-id="element-105">
              {['Calm in your body, not just "coping" in your head', 'A clearer mind and fewer spirals', 'Better sleep and more energy', 'Less self-criticism and more self-trust', 'Space to enjoy work and home again', "Be the 'You' you recognise"].map((item, i) => <div key={i} className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm border border-blue-50" data-id="element-106">
                  <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-107" />
                  <span className="text-[#1e3a5f] font-medium" data-id="element-108">{item}</span>
                </div>)}
            </div>
          </div>
        </section>

        {/* SECTION 3 — WHAT I DO */}
        <section className="py-20 px-4 bg-white text-center" data-id="element-109">
          <div className="max-w-3xl mx-auto space-y-8" data-id="element-110">
            <h3 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] leading-tight" data-id="element-111">
              Hypnotherapy for stress, anxiety, high-functioning anxiety and
              burnout.
            </h3>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-112">
              I work with professionals and managers who are outwardly capable,
              but internally running on stress. If you're dealing with anxiety,
              high-functioning anxiety, overwhelm or burnout, hypnotherapy can
              help you settle your nervous system, quiet the mental noise, and
              feel more in control again.
            </p>
            <div className="inline-block bg-[#eef4fb] px-6 py-3 rounded-full" data-id="element-113">
              <p className="font-semibold text-[#1e3a5f]" data-id="element-114">
                Based in Shirley, Solihull — supporting clients across Solihull
                and online.
              </p>
            </div>
          </div>
        </section>

        {/* SECTION 4 — WHY ME */}
        <section className="py-20 px-4 bg-[#1e3a5f] text-white" data-id="element-115">
          <div className="max-w-3xl mx-auto" data-id="element-116">
            <h3 className="text-3xl md:text-4xl font-bold mb-10 text-center" data-id="element-117">
              Why work with me?
            </h3>
            <div className="space-y-6 text-lg text-blue-50 leading-relaxed md:text-center" data-id="element-118">
              <p data-id="element-119">
                Because I get this. I'm not guessing what it feels like to look
                like you're coping while everything inside is loud, tense and
                exhausted. I've lived it. And I work best with high performers
                because I understand the pressure, the standards, and the
                constant mental load.
              </p>
              <p data-id="element-120">
                This isn't "just hypnotherapy" either. Depending on what you
                need, I integrate tools like breathwork and tapping to help your
                body and mind settle, so you're not fighting yourself every day.
              </p>
              <p className="font-semibold text-white" data-id="element-121">
                My work has been recognised with awards — but what matters most
                is how you feel walking out of the room.
              </p>
            </div>
          </div>
        </section>

        {/* SECTION 5 — WHAT HAPPENS NEXT */}
        <section className="py-20 px-4 bg-white" data-id="element-122">
          <div className="max-w-5xl mx-auto" data-id="element-123">
            <h3 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] text-center mb-16" data-id="element-124">
              Here's what happens next.
            </h3>
            <div className="grid md:grid-cols-3 gap-10 mb-16" data-id="element-125">
              {[{
              step: '1',
              title: 'Book a free 15-minute call',
              desc: 'Can we get you the results you want?'
            }, {
              step: '2',
              title: 'Choose in-person or online',
              desc: 'Sessions in Shirley, Solihull or from home'
            }, {
              step: '3',
              title: 'We get started',
              desc: 'Calm, practical sessions tailored to you (individual or packages available)'
            }].map((item, i) => <div key={i} className="text-center space-y-4 relative" data-id="element-126">
                  {i !== 2 && <div className="hidden md:block absolute top-8 left-[60%] w-full h-[2px] bg-gray-100 -z-10" data-id="element-127"></div>}
                  <div className="w-16 h-16 bg-[#eef4fb] text-[#1e3a5f] rounded-full flex items-center justify-center text-2xl font-bold mx-auto shadow-sm border-4 border-white" data-id="element-128">
                    {item.step}
                  </div>
                  <h4 className="text-xl font-bold text-[#1e3a5f]" data-id="element-129">
                    {item.title}
                  </h4>
                  <p className="text-gray-600" data-id="element-130">{item.desc}</p>
                </div>)}
            </div>
            <div className="text-center" data-id="element-131">
              <a href="https://mindability-hypnotherapy.co.uk/fees-booking/" className="inline-flex items-center justify-center bg-[#1e3a5f] text-white px-8 py-4 rounded-lg font-bold text-sm shadow-md hover:bg-[#162d4a] transition-colors" data-id="element-132">
                Book a free 15-minute call{' '}
                <ArrowRight className="ml-2 w-4 h-4" data-id="element-133" />
              </a>
            </div>
          </div>
        </section>

        {/* SECTION 6 — REVIEWS */}
        <section className="py-20 px-4 bg-[#eef4fb]" data-id="element-134">
          <div className="max-w-6xl mx-auto" data-id="element-135">
            <div className="text-center mb-14" data-id="element-136">
              <h3 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-4" data-id="element-137">
                Google reviews
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto text-lg" data-id="element-138">
                If you want to see what this is like for people who felt exactly
                like you do now, the Google reviews are all there.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-139">
              {/* Review Card 1 */}
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col" data-id="element-140">
                <div className="flex items-center gap-1 text-yellow-400 mb-6" data-id="element-141">
                  <Star className="w-5 h-5 fill-current" data-id="element-142" />
                  <Star className="w-5 h-5 fill-current" data-id="element-143" />
                  <Star className="w-5 h-5 fill-current" data-id="element-144" />
                  <Star className="w-5 h-5 fill-current" data-id="element-145" />
                  <Star className="w-5 h-5 fill-current" data-id="element-146" />
                </div>
                <p className="text-gray-700 italic mb-8 flex-grow leading-relaxed" data-id="element-147">
                  "After struggling with anxiety I decided to seek the help of a
                  professional. Choosing Mindability was the best decision I
                  made. Asha is incredibly welcoming, professional and put me at
                  ease straight away."
                </p>
                <div className="flex items-center justify-between mt-auto pt-6 border-t border-gray-50" data-id="element-148">
                  <div data-id="element-149">
                    <p className="font-bold text-[#1e3a5f]" data-id="element-150">Kim Freeman</p>
                    <p className="text-sm text-gray-500" data-id="element-151">1 year ago</p>
                  </div>
                  <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm border border-gray-100" data-id="element-152">
                    <span className="text-blue-600 font-bold text-sm" data-id="element-153">G</span>
                  </div>
                </div>
              </div>

              {/* Review Card 2 */}
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col" data-id="element-154">
                <div className="flex items-center gap-1 text-yellow-400 mb-6" data-id="element-155">
                  <Star className="w-5 h-5 fill-current" data-id="element-156" />
                  <Star className="w-5 h-5 fill-current" data-id="element-157" />
                  <Star className="w-5 h-5 fill-current" data-id="element-158" />
                  <Star className="w-5 h-5 fill-current" data-id="element-159" />
                  <Star className="w-5 h-5 fill-current" data-id="element-160" />
                </div>
                <p className="text-gray-700 italic mb-8 flex-grow leading-relaxed" data-id="element-161">
                  "I went to see Asha suffering from anxiety and stress. She
                  explained to me how the brain works before we started any
                  hypnotherapy. The sessions were so relaxing and I felt a
                  difference after the first one."
                </p>
                <div className="flex items-center justify-between mt-auto pt-6 border-t border-gray-50" data-id="element-162">
                  <div data-id="element-163">
                    <p className="font-bold text-[#1e3a5f]" data-id="element-164">Lynette Chandler</p>
                    <p className="text-sm text-gray-500" data-id="element-165">2 years ago</p>
                  </div>
                  <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm border border-gray-100" data-id="element-166">
                    <span className="text-blue-600 font-bold text-sm" data-id="element-167">G</span>
                  </div>
                </div>
              </div>

              {/* Review Card 3 */}
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col" data-id="element-168">
                <div className="flex items-center gap-1 text-yellow-400 mb-6" data-id="element-169">
                  <Star className="w-5 h-5 fill-current" data-id="element-170" />
                  <Star className="w-5 h-5 fill-current" data-id="element-171" />
                  <Star className="w-5 h-5 fill-current" data-id="element-172" />
                  <Star className="w-5 h-5 fill-current" data-id="element-173" />
                  <Star className="w-5 h-5 fill-current" data-id="element-174" />
                </div>
                <p className="text-gray-700 italic mb-8 flex-grow leading-relaxed" data-id="element-175">
                  "I recently had hypnotherapy with Asha for my fear of flying.
                  Myself and Asha had several sessions leading up to my holiday
                  and I can honestly say it was the most relaxed I have ever
                  been on a flight."
                </p>
                <div className="flex items-center justify-between mt-auto pt-6 border-t border-gray-50" data-id="element-176">
                  <div data-id="element-177">
                    <p className="font-bold text-[#1e3a5f]" data-id="element-178">Lauren Hackett</p>
                    <p className="text-sm text-gray-500" data-id="element-179">2 years ago</p>
                  </div>
                  <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm border border-gray-100" data-id="element-180">
                    <span className="text-blue-600 font-bold text-sm" data-id="element-181">G</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center" data-id="element-182">
              <a href="https://www.google.com/search?q=mindability+hypnotherapy+reviews" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-white text-[#1e3a5f] border-2 border-[#1e3a5f] px-8 py-3 rounded-lg font-bold text-sm hover:bg-gray-50 transition-colors" data-id="element-183">
                Read all Google reviews
              </a>
            </div>
          </div>
        </section>

        {/* SECTION 7 — FINAL CTA */}
        <section className="py-24 px-4 bg-white text-center" data-id="element-184">
          <div className="max-w-3xl mx-auto space-y-10" data-id="element-185">
            <h3 className="text-3xl md:text-5xl font-bold text-[#1e3a5f] leading-tight" data-id="element-186">
              If you're functioning but not living, let's change that.
            </h3>
            <a href="https://mindability-hypnotherapy.co.uk/book-now/" className="inline-flex items-center justify-center bg-[#1e3a5f] text-white px-10 py-5 rounded-lg font-bold text-base shadow-lg hover:bg-[#162d4a] transition-colors" data-id="element-187">
              Book a free 15 minute call <ArrowRight className="ml-2 w-5 h-5" data-id="element-188" />
            </a>
          </div>
        </section>
      </main>
    </div>;
}